export const API_BASE_URL = "https://investro-api.onrender.com";
export const FRONTEND_URL = "https://investro.onrender.com";
export const DASHBOARD_URL = "https://investro-dashboard.onrender.com";
